import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, of, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Image } from 'src/app/interfaces/image';
import { ImageService } from 'src/app/services/image.service';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
  standalone: false,
})
export class ImageUploadComponent implements OnInit {
  uploadedImage?: Image;
  uploadedImageDescription = '';
  uploadProgress = 0;
  uploadSub: Subscription | null;

  constructor(
    private imageService: ImageService,
    private dialogRef: MatDialogRef<ImageUploadComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      handoverId: number;
      hideDescription: boolean;
    }
  ) {
    this.uploadSub = null;
  }

  ngOnInit(): void {
    // this.imageService.endpointUrl = `/dhoapi/handovers/${this.data.handoverId}/wellheads/images`;
  }

  ngOnDestroy(): void {
    if (null != this.uploadSub) {
      this.uploadSub.unsubscribe();
    }
  }

  /**
   * Returns the uploaded image if accepted, undefined otherwise.
   * @param accept boolean indicating if the closing command comes from the accept or cancel button
   * @returns void
   */
  closeDialog(accept: boolean): void {
    if (accept) {
      if ('' != this.uploadedImageDescription && !this.data.hideDescription) {
        this.updateImage(this.uploadedImageDescription).subscribe(
          (updatedImages) => {
            if (null != updatedImages && updatedImages.length) {
              this.uploadedImage = updatedImages[0];
            }
            this.dialogRef.close(this.uploadedImage);
          }
        );
      } else {
        this.dialogRef.close(this.uploadedImage);
      }
    } else {
      if (this.uploadedImage) {
        this.deleteImage().subscribe(() => this.dialogRef.close());
      } else {
        this.dialogRef.close();
      }
    }
    return;
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append('image', file);

      const upload$ = this.imageService
        .createImage(formData)
        .pipe(finalize(() => this.reset()));

      this.uploadSub = upload$.subscribe(
        (event: Image[] | HttpEvent<Image[]>) => {
          if ('type' in event) {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                // Process upload still in progress
                this.uploadProgress = Math.round(
                  100 * (event.loaded / (event.total || 1))
                );
                break;
              case HttpEventType.Response:
                // Process the final response
                if (event.body?.length) {
                  this.uploadedImage = event.body[0] as Image;
                }
                break;
              default:
                break;
            }
          }
        }
      );
    }
  }

  cancelUpload(): void {
    if (null != this.uploadSub) {
      this.uploadSub.unsubscribe();
    }
    this.reset();
  }

  reset(): void {
    this.uploadProgress = 0;
    this.uploadSub = null;
  }

  updateImage(description: string): Observable<Image[] | null> {
    if (this.uploadedImage) {
      const imageToUpdate = this.uploadedImage;
      imageToUpdate.imageDescription = description;
      return this.imageService.updateImage(imageToUpdate);
    }
    return of(null);
  }

  deleteImage(): Observable<boolean> {
    if (this.uploadedImage) {
      return this.imageService.deleteImage(this.uploadedImage);
    }
    return of(false);
  }
}
